import { Link } from 'react-router-dom';
import SectionTitle from '@/components/feature/SectionTitle';
import { characters } from '@/mocks/manga';

export default function CharactersPreview() {
  const chars = characters.slice(0, 4);
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <SectionTitle
            kicker="人物角色"
            title="在同一屋檐下相遇的他们"
            desc="每一个角色都有着自己的故事与温度，他们的相遇让这段同居日常变得鲜活起来。"
          />
          <Link
            to="/characters"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
          >
            查看全部角色
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {chars.map((c) => (
            <article key={c.id} className="overflow-hidden rounded-lg bg-background-100">
              <img
                src={c.image}
                alt={`泡在我家的辣妹角色${c.name}插画`}
                className="h-56 w-full object-cover object-top"
              />
              <div className="p-4">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg text-foreground-900">{c.name}</h3>
                  <span className="text-xs font-medium text-secondary-700">{c.role}</span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.intro}</p>
                <div className="mt-3 flex flex-wrap gap-2">
                  {c.tags.map((t) => (
                    <span key={t} className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-800">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}